import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'Text';
import { Button } from 'Button';
import { ExamInfoBox } from './ExamInfoBox';
import '../locales/streamDashboard/streamDashboard-en.json';

/*
    Below sm, after the stream starts, the schedule hides behind VIEW SCHEDULE. The parent owns that state.
*/

type Props = {
    // Already formatted for the current user's locale and time zone.
    formattedExamOpenTime: string | null;
    timeLimitHours: number | null;
    showSchedule: boolean;
    onShowSchedule: () => void;
    className?: string;
};

export const ExamScheduleBox: FC<Props> = ({
    formattedExamOpenTime,
    timeLimitHours,
    showSchedule,
    onShowSchedule,
    className,
}) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'streamDashboard.streamDashboard' });

    if (!formattedExamOpenTime) return null;

    if (!showSchedule) {
        return (
            <Button color="slate-grey" fullWidth onPress={onShowSchedule} className={className}>
                {t('view_schedule')}
            </Button>
        );
    }

    return (
        <ExamInfoBox caption={t('schedule')} className={className}>
            <div className="sm:text-sm">
                <Text as="div" weight="semibold" className="text-black">
                    {t('exam_begins')}
                </Text>
                <p>{formattedExamOpenTime}</p>
            </div>
            <div className="sm:text-sm">
                <Text as="div" weight="semibold" className="text-black">
                    {t('time_limit')}
                </Text>
                <p>{t('the_exam_time_will_begin', { timeLimitHours })}</p>
            </div>
        </ExamInfoBox>
    );
};
